import {
  MEET_API_URL,
  TEAMS_APP_URL,
  TEAMS_APP_URL_2,
} from 'src/constants/call';

export type EnvironmentPlatform =
  'zoom' | 'teams' | 'google-meet' | 'webex' | 'web';

export function isIframe() {
  return window.location !== window.parent.location;
}

// The Teams desktop client puts "Teams" in the user agent; Teams in a browser
// embeds the app in an iframe served from one of the Teams origins.
export function isTeamsEnvironment(): boolean {
  return Boolean(
    navigator.userAgent.includes('Teams') ||
    window.location.ancestorOrigins?.contains(TEAMS_APP_URL) ||
    window.location.ancestorOrigins?.contains(TEAMS_APP_URL_2),
  );
}

// Which meeting platform embeds the app. Order matters: Zoom first, then Teams,
// then Meet, and any other iframe is taken to be Webex.
export function detectEnvironmentPlatform(): EnvironmentPlatform {
  if (navigator.userAgent.includes('Zoom')) {
    return 'zoom';
  }

  if (isTeamsEnvironment()) {
    return 'teams';
  }

  if (window.location.ancestorOrigins?.contains(MEET_API_URL)) {
    return 'google-meet';
  }

  if (isIframe()) {
    return 'webex';
  }

  return 'web';
}

export function isEmbeddedPlatform(): boolean {
  return detectEnvironmentPlatform() !== 'web';
}
